import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ContentOpinionWidget } from '../Content';

export interface IFaqItem {
    id: number;
    question: string;
    answer: string;
}

interface IFaqWidgetProps {
    faq: IFaqItem;
    isOpen: boolean;
    opinionLabel: string;
    opinionVotedLabel: string;
    onClick: (faq: IFaqItem) => void;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictSend: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
}

export class FaqWidget extends Component<IFaqWidgetProps> {
    handleClick = () => {
        this.props.onClick(this.props.faq);
    };

    render() {
        return (
            <li
                className={
                    'faq-item panel' + (this.props.isOpen ? ' open' : '')
                }
            >
                <div
                    className="faq-item--title accordion-title"
                    onClick={this.handleClick}
                >
                    <button
                        className="accordion-link"
                        data-toggle="accordion"
                        aria-expanded={this.props.isOpen}
                        aria-controls="collapseThree"
                        data-parent="#accordion"
                    >
                        <h4>{this.props.faq.question}</h4>
                    </button>
                </div>

                <div className="accordion-body">
                    <article className="faq-item--content">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: this.props.faq.answer,
                            }}
                        />

                        <ContentOpinionWidget
                            contentId={this.props.faq.id}
                            opinionLabel={this.props.opinionLabel}
                            opinionVotedLabel={this.props.opinionVotedLabel}
                            isServiceFse="false"
                            dictSend={this.props.dictSend}
                            dictCommentSuccess={this.props.dictCommentSuccess}
                            dictCommentFail={this.props.dictCommentFail}
                            dictCommentInvite={this.props.dictCommentInvite}
                            dictYourComment={this.props.dictYourComment}
                            dictYes={this.props.dictYes}
                            dictNo={this.props.dictNo}
                            contactString={this.props.contactString}
                            contactUrl={this.props.contactUrl}
                        />
                    </article>
                </div>
            </li>
        );
    }
}

WidgetHelper.register(FaqWidget, 'faq-widget');
